import GlassCard from "@/v2/components/GlassCard";
import SprintStepForm, { StepDraft } from "./SprintStepForm";
import { getStepTitle } from "./SprintRoadmap";
import type {
  RealityCheckMode,
  V2RealityCheck,
  V2SprintSubmission,
} from "@/v2/hooks/useV2Sprint";

const STEP_INTROS: Record<number, string> = {
  1: "Identifica le 1-3 ipotesi che, se false, fanno crollare l'idea. Scegli quella da testare ora.",
  2: "Definisci il protocollo del test: target, canale, azione misurata, metrica e soglia di successo.",
  3: "Azioni pratiche, checklist e metriche da raccogliere per eseguire il test definito nello Step 2.",
  4: "Raccogli evidenze grezze: numeri, screenshot, citazioni. Niente storytelling.",
  5: "Prendi una decisione esplicita basata sulle evidenze: continua, itera o fermati.",
};

export default function SprintStepCard({
  step,
  submission,
  realityCheck,
  realityCheckMode,
  allSubmissions,
  readOnly,
  saving,
  isFinalStep,
  isStepCompleted,
  sprintStartedAt,
  sprintId,
  onSubmit,
  onSaveDraft,
  onGoToStep,
}: {
  step: number;
  submission: V2SprintSubmission | undefined;
  realityCheck: V2RealityCheck | null;
  realityCheckMode: RealityCheckMode;
  allSubmissions: V2SprintSubmission[];
  readOnly: boolean;
  saving: boolean;
  isFinalStep: boolean;
  isStepCompleted: boolean;
  sprintStartedAt?: string | null;
  sprintId?: string | null;
  onSubmit: (draft: StepDraft) => Promise<void> | void;
  onSaveDraft?: (draft: StepDraft, opts?: { unlockCall?: boolean }) => Promise<void> | void;
  onGoToStep?: (step: number) => void;
}) {
  // Dynamic CTA label (steps 3, 4, 5 manage their own internal CTAs)
  const submitLabel = isStepCompleted
    ? "Salva modifiche"
    : isFinalStep
      ? "Completa Sprint"
      : step === 2
        ? "Ho costruito il mio MVP →"
        : `Completa Step ${step} e continua`;

  return (
    <GlassCard className="!p-5 md:!p-6">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <p className="text-xs uppercase tracking-widest text-secondary">
            Step {step} di 5
          </p>
          <h2 className="text-xl md:text-2xl font-bold mt-1">{getStepTitle(step)}</h2>
          <p className="text-sm text-slate-300 mt-2">{STEP_INTROS[step]}</p>
        </div>
      </div>

      <SprintStepForm
        step={step}
        submission={submission}
        realityCheck={realityCheck}
        realityCheckMode={realityCheckMode}
        allSubmissions={allSubmissions}
        readOnly={readOnly}
        saving={saving}
        submitLabel={submitLabel}
        isStepCompleted={isStepCompleted}
        sprintStartedAt={sprintStartedAt ?? null}
        sprintId={sprintId ?? null}
        onSubmit={onSubmit}
        onSaveDraft={onSaveDraft}
        onGoToStep={onGoToStep}
      />
    </GlassCard>
  );
}
